/**
 * Safe alternatives to eval() for expression evaluation.
 * These functions replace dynamic eval() calls to comply with
 * Content-Security-Policy without unsafe-eval.
 */

export function safeCompare(left: any, operator: string, right: any): boolean {
  const l: any = isNaN(Number(left)) ? String(left) : Number(left);
  const r: any = isNaN(Number(right)) ? String(right) : Number(right);
  switch (operator.trim()) {
    case '>':   return l > r;
    case '<':   return l < r;
    case '>=':  return l >= r;
    case '<=':  return l <= r;
    case '==':  return l == r;
    case '===': return l === r;
    case '!=':  return l != r;
    case '!==': return l !== r;
    default:    return false;
  }
}

export function safeArithmetic(expression: string): number | null {
  const match = expression.trim().match(/^(-?[\d.]+)\s*([+\-*/])\s*(-?[\d.]+)$/);
  if (!match) return null;
  const left = parseFloat(match[1]);
  const op = match[2];
  const right = parseFloat(match[3]);
  switch (op) {
    case '+': return left + right;
    case '-': return left - right;
    case '*': return left * right;
    case '/': return right !== 0 ? left / right : null;
    default:  return null;
  }
}

export function safePropertyAccess(obj: any, path: string): any {
  return path.split('.').reduce((acc: any, key: string) => acc?.[key], obj);
}
